import React from 'react';
import styled from 'styled-components';
import { media } from '../themes/theme';
import { useIsViewportDesktop } from '../../hooks/useIsViewport';
import { SocialNavigation } from './SocialNavigation';
const StyledFooter = styled.footer `
  background: ${props => props.theme.Gray};
  color: ${props => props.theme.White};
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.875rem;
  padding: 3rem 0 3.75rem 0;
`;
const FooterRow = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  ${media.laptop `
    margin-bottom: 3.25rem;
    flex-direction: row;
  `}
`;
const FooterRowCentered = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.laptop `
    margin-bottom: 3.25rem;
    flex-direction: row;
  `}
`;
const FooterInner = styled.div `
  max-width: ${props => props.theme.application.maxContentWidth};
  padding-left: 1em;
  padding-right: 1em;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  /* stylelint-disable selector-type-no-unknown */
  & > ${FooterRow}:last-child {
    margin-bottom: 0;
  }
`;
const Copyright = styled.div `
  display: flex;
  justify-content: center;
  font-size: 0.8125rem;

  ${media.laptop `
    justify-content: flex-end;
    font-size: .875rem;
  `}
`;
const NavWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4.5rem;

  ${media.laptop `
    justify-content: flex-end;
    margin-bottom: 0;
  `}
`;
const MetaNavSlot = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.25rem;
  margin-bottom: 3.5rem;

  ${media.laptop `
    margin-top: 0;
    margin-bottom: 0;
  `}
`;
const SocialSlot = styled.div `
  display: flex;
  margin-bottom: 1.75rem;
  justify-content: center;

  ${media.laptop `
    margin-bottom: 4.0625rem;
    justify-content: flex-start;
    margin-bottom: 0;
  `}
`;
const FeedbackSlot = styled.div `
  margin-bottom: 2rem;

  ${media.laptop `
    margin-bottom: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `}
`;
const ChildrenSlot = styled.div `
  margin-bottom: 3.75rem;

  ${media.laptop `
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 1.5rem;
  `}
`;
const TopLinks = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 4.5rem;
  font-size: 1rem;

  ${media.laptop `
    font-size: .875rem;
    width: auto;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;

    > a {
      margin-right: 3rem;
    }

    a:last-child {
      margin-right: 0;
    }
  `}
`;
const ClosingText = styled.div `
  margin-top: 2rem;

  ${media.laptop `
    margin-top: 0;
  `}
`;
export function Footer({ copyright, dataTestId = undefined, metaNavigation, legalNavigation, topLinks, feedback = null, children = null, socialMediaLinks, closingText = null, }) {
    return (React.createElement(StyledFooter, { "data-testid": dataTestId },
        React.createElement(FooterInner, null,
            React.createElement(FooterRow, null,
                React.createElement(TopLinks, null, topLinks),
                feedback && React.createElement(FeedbackSlot, null, feedback),
                React.createElement(NavWrapper, null, metaNavigation)),
            children && React.createElement(ChildrenSlot, null, children),
            useIsViewportDesktop() && (React.createElement(React.Fragment, null,
                React.createElement(FooterRowCentered, null, legalNavigation && React.createElement(MetaNavSlot, null, legalNavigation)),
                React.createElement(FooterRow, null,
                    React.createElement(SocialSlot, null,
                        React.createElement(SocialNavigation, { socialMediaLinks: socialMediaLinks })),
                    React.createElement(Copyright, null, copyright)))),
            !useIsViewportDesktop() && (React.createElement(React.Fragment, null,
                React.createElement(FooterRow, null,
                    React.createElement(SocialSlot, null,
                        React.createElement(SocialNavigation, { socialMediaLinks: socialMediaLinks }))),
                React.createElement(FooterRowCentered, null, legalNavigation && React.createElement(MetaNavSlot, null, legalNavigation)),
                React.createElement(FooterRow, null,
                    React.createElement(Copyright, null, copyright)))),
            closingText && (React.createElement(FooterRow, null,
                React.createElement(ClosingText, null, closingText))))));
}
